import { Link } from 'react-router-dom';

interface InboxViewLinkProps {
    to: string;
    state: object;
    ariaLabel: string;
}

// A link, so it opens in a new tab too; it carries the list's filters for Back and Prev/Next.
export function InboxViewLink({ to, state, ariaLabel }: InboxViewLinkProps) {
    return (
        <Link
            to={to}
            state={state}
            aria-label={ariaLabel}
            className="inline-flex h-7 items-center rounded-md border border-gray-300 bg-white px-3 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50"
        >
            View
        </Link>
    );
}
